// Real, stored policy-version workflow statuses (the persisted values are the PT labels).
// Mirrors vo-api-policy's POLICY_VERSION_STATUS / POLICY_VERSION_TRANSITIONS — the backend is
// the enforcing side; these helpers only decide what the UI offers.
export const POLICY_VERSION_STATUS = {
  STARTED: 'Iniciado',
  SUBMITTED: 'Concluído',
  REVIEWED: 'Revisado',
  APPROVED: 'Aprovado',
  PUBLISHED: 'Publicado',
};

// A version may be edited (content, attachment) or deleted only while it is a draft.
export const isPolicyVersionEditable = (policyVersion) =>
  policyVersion?.status === POLICY_VERSION_STATUS.STARTED;

// Backend workflow refusals come back as { code, message }; show the translated code when known.
export const policyWorkflowErrorMessage = (t, error) => {
  const code = error?.response?.data?.code;
  const message = error?.response?.data?.message;
  return code ? t(`policy:workflowErrors.${code}`, { defaultValue: message }) : message;
};
